import { render, staticRenderFns } from "./BettingAdd.vue?vue&type=template&id=26e36ba6&scoped=true"
import script from "./BettingAdd.vue?vue&type=script&lang=js"
export * from "./BettingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e36ba6",
  null
  
)

export default component.exports